// removed by extract-text-webpack-plugin
module.exports = {"section":"MainNavSection__section___1QWNA","section-bottom":"MainNavSection__section-bottom___H8uTk MainNavSection__section___1QWNA","link":"MainNavSection__link___cEdDv","icon":"MainNavSection__icon___37Hci","active":"MainNavSection__active___2qbx2 MainNavSection__link___cEdDv","label":"MainNavSection__label___ks1wF","label-hidden":"MainNavSection__label-hidden___5U8f- MainNavSection__label___ks1wF","pulsate":"MainNavSection__pulsate___2i_4v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/MainNavSection.scss
// module id = 519
// module chunks = 0